import request from '@/utils/request'


// 查询代理商列表
export function listAgents(query) {
  return request({
    url: '/user/agents/list',
    method: 'get',
    params: query
  })
}

// 查询代理商分页
export function pageAgents(query) {
  return request({
    url: '/user/agents/page',
    method: 'get',
    params: query
  })
}

// 查询代理商详细
export function getAgents(data) {
  return request({
    url: '/user/agents/detail',
    method: 'get',
    params: data
  })
}

// 新增代理商
export function addAgents(data) {
  return request({
    url: '/user/agents/add',
    method: 'post',
    data: data
  })
}

// 修改代理商
export function updateAgents(data) {
  return request({
    url: '/user/agents/edit',
    method: 'post',
    data: data
  })
}

// 删除代理商
export function delAgents(data) {
  return request({
    url: '/user/agents/delete',
    method: 'post',
    data: data
  })
}
